import { getWindow, jsonParse } from '@sitecore-search/common';
import CookieHandler from './cookieHandler.js';
import LocalStorageHandler from './localStorageHandler.js';
const DEFAULT_EXPIRY = 300000;
let storageStrategy;
class Storage {
    static init(useStorage) {
        if (useStorage && getWindow().localStorage) {
            storageStrategy = new LocalStorageHandler();
        }
        else {
            storageStrategy = new CookieHandler();
        }
    }
    static set(key, value, expire) {
        storageStrategy.set(key, value, expire || DEFAULT_EXPIRY);
    }
    static get(key) {
        let storageValue = storageStrategy.get(key);
        const parsedValue = storageValue ? jsonParse(storageValue) : {};
        if (storageValue === 'undefined') {
            storageValue = undefined;
        }
        return storageValue && parsedValue ? parsedValue : storageValue;
    }
    static remove(key) {
        storageStrategy.remove(key);
    }
}
export default Storage;
